module.exports = __webpack_public_path__ + "img/安全管理示例图_1.ad4f0e40.png";